import React from 'react';
import {
    Subtitle,
    BlackFullLabel,
    MediumSecondaryButton,
    DiamondBullet
} from '@worthy-npm/clarity'
import {isMobile} from 'helpers/ApplicationHelper'

const SmallCTAcard = (props) => {
    let labelColor, labelText, ctaText
    
    switch (props.type) {
        case 'resource':
            labelText = 'Resource'
            labelColor = '#C7427C'
            ctaText = 'View'
            break;
        case 'tool':
            labelText = 'Tool'
            labelColor = '#E38E1F'
            ctaText = 'Try'
            break;
        default:
            labelText = 'Info'
            labelColor = ''
            ctaText = 'Info'
            break;
    }

    return (
        <div className="small-cta-card d-flex flex-col">
            <BlackFullLabel text={labelText} overrideCSS={{backgroundColor: labelColor, color: 'white', textTransform: 'none', marginBottom: '12px'}}/>
            <Subtitle text={props.title} overrideCSS={{fontSize: isMobile()? '22px': '', marginBottom: '12px'}}/>
            <DiamondBullet iconColor="grey" helper={true} html={props.subtitle} overrideCSS={{fontSize: isMobile()? '16px': '', marginBottom: '36px'}}/>
            <MediumSecondaryButton text={ctaText}
                                   overrideCSS={{border: '2px solid #2F80ED', color: '#2F80ED', minWidth: '115px', borderRadius: '2px'}}
                                   disableAnimation={true}
                                   click={(stopAnimation)=>props.CTAcallBack(stopAnimation)}/>
        </div>
    );
}

export default SmallCTAcard;